/**
 * Checks to see if both edges of the element are visible
 * @param container
 * @param element
 * @returns `true` or `false`
 */
export function elementIsFullyVisible(container, element) {
  return !elementRightIsClipped(container, element) && !elementLeftIsClipped(container, element);
}

/**
 * Scrolls an element horizontally
 * @param element
 * @param globalBounds
 * @param scrollTo
 */
export function scrollHorizontal(element, globalBounds, scrollTo) {
  const scrollWidth = element.scrollWidth;
  if (scrollWidth <= element.offsetWidth) {
    return;
  }
  const bounds = element.getBoundingClientRect();
  const relativeLeft = globalBounds.left - bounds.left;
  const relativeRight = globalBounds.right - bounds.right;
  const padding = 1;
  if (relativeLeft <= 0 && scrollTo !== 'next') {
    element.scrollLeft = element.scrollLeft + relativeLeft - padding;
  } else if (relativeRight > 0 && scrollTo !== 'back') {
    element.scrollLeft = element.scrollLeft + relativeRight + padding;
  }
}

/**
 * Checks to see if the distance to the left of an `element` + 1
 * is farther from the right of the viewport than the left of a `container` element
 * @param container
 * @param element
 * @returns `true` or `false`
 */
export function elementLeftIsClipped(container, element) {
  const cRect = container.getBoundingClientRect();
  const eRect = element.getBoundingClientRect();
  return eRect.left + 1 < cRect.left;
}

/**
 * Checks to see if the distance to the right of an `element` + 1
 * is farther from the left of the viewport than the right of a `container` element
 * @param container
 * @param element
 * @returns  `true` or `false`
 */
export function elementRightIsClipped(container, element) {
  const cRect = container.getBoundingClientRect();
  const eRect = element.getBoundingClientRect();
  return eRect.left + eRect.width - 1 > cRect.left + cRect.width;
}

/**
 * Scrolls to the next element in a container
 * @param direction
 * @param containerRef
 * @param contentsRef
 * @param isRTL
 */
export function moveFocus(direction, containerRef, contentsRef, isRTL) {
  const container = containerRef.current;
  const contents = contentsRef && contentsRef.current ? contentsRef.current : undefined;
  if (!container) return;
  if (!contents) return;
  let itemIndex = -1;
  if (direction === 'next') {
    const clipCalculatingFn = isRTL ? elementLeftIsClipped : elementRightIsClipped;
    // Find the first element whose right edge is left of the container
    itemIndex = contents.findIndex(content => content && clipCalculatingFn(container, content));
  } else {
    const clipCalculatingFn = isRTL ? elementRightIsClipped : elementLeftIsClipped;
    // Find the last element whose left edge is right of the container
    for (let i = contents.length - 1; i >= 0; i--) {
      const content = contents[i];
      if (content && clipCalculatingFn(container, content)) {
        itemIndex = i;
        break;
      }
    }
  }
  if (itemIndex === -1) {
    return;
  }
  const item = contents[itemIndex];
  if (!item) {
    return;
  }
  direction = isRTL ? direction === 'back' ? 'next' : 'back' : direction;
  scrollHorizontal(container, item.getBoundingClientRect(), direction);
}
//# sourceMappingURL=horizontalScroll.js.map